import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminCatalogComponent } from '@banyan/modules/admin/components/catalog/admin-catalog/admin-catalog.component';
import { AdminRequestDetailsComponent } from '@banyan/modules/admin/components/request/admin-request-details/admin-request-details.component';

import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { AdminRequestsComponent } from './components/request/admin-requests/admin-requests.component';
import { canExitAdminRequestGuard } from './guard/can-exit-admin-request.guard';


const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'requests',
        pathMatch: 'full',
      },
      {
        path: 'requests',
        component: AdminRequestsComponent,
      },
      {
        path: 'request/details/:id/:endUseId',
        component: AdminRequestDetailsComponent,
        canDeactivate: [canExitAdminRequestGuard],
      },
      {
        path: 'catalogue',
        component: AdminCatalogComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {
}
